/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vast_Rosy_Fox_DashInputs */

const en_vast_rosy_fox_dash = /** @type {(inputs: Vast_Rosy_Fox_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will replace all current data groups and requests. Continue?`)
};

const de_vast_rosy_fox_dash = /** @type {(inputs: Vast_Rosy_Fox_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dies ersetzt alle aktuellen Datengruppen und Datenquellen. Fortfahren?`)
};

/**
* | output |
* | --- |
* | "This will replace all current data groups and requests. Continue?" |
*
* @param {Vast_Rosy_Fox_DashInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vast_rosy_fox_dash = /** @type {((inputs?: Vast_Rosy_Fox_DashInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vast_Rosy_Fox_DashInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vast_rosy_fox_dash(inputs)
	return de_vast_rosy_fox_dash(inputs)
});